export default __webpack_public_path__ + "static/media/19.8e8dc3cb.png";